module.exports = __webpack_public_path__ + "img/delete.bfab52a5.svg";